import React, { Component } from "react";
import { render } from "react-dom";
import SiteNavbar from "./navbar/navbar.js";
import Footer from "./footer/footer.js";
import Home from "./homepage/home";
import OnlyMapPage from "./onlymappage.js";
import PSAPStatistic from "./map-section/statistic.js";
import StatisticEmbed from "./map-section/statistic-embed.js";
import JustMap from "./map-section/justmap.js";
import MapBox from "./map-section/map.js";
import "./style.scss";
import "./_skel.scss";
import "bootstrap/dist/css/bootstrap.min.css";

import { BrowserRouter as Router } from "react-router-dom";
import { Switch, Route, Routes } from "react-router-dom";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <Router>
        <Switch>
          <Route exact path="/">
            <div>
              {/** Navbar component for website */}
              <SiteNavbar/>

              {/** This is the main component of the website that displays all of the other components:
               * ---> Map component with search bar/search result/statistic component above it
               * ---> Infographic component that displays step-by-step instructions on texting 911
               * ---> FAQ component that displays the FAQ section of the page.
               */}
              <Home/>
              
              {/** Footer component for website */}
              <Footer/>
            </div>
          </Route>
          <Route exact path="/embed">
            <OnlyMapPage />
          </Route>

          <Route exact path="/percentageembed">
            <StatisticEmbed />
          </Route>
          
          {/* Default route for any unmatched paths */}
          <Route path="*">
            <div>
              {/** Navbar component for website */}
              <SiteNavbar/>

              {/** This is the main component of the website that displays all of the other components:
               * ---> Map component with search bar/search result/statistic component above it
               * ---> Infographic component that displays step-by-step instructions on texting 911
               * ---> FAQ component that displays the FAQ section of the page.
               */}
              <Home/>
              
              {/** Footer component for website */}
              <Footer/>
            </div>
          </Route>
        </Switch>
      </Router>
    );
  }
}

render(<App />, document.getElementById("root"));